export enum ListInvoiceSorting {
    DOCUMENT_DATE = 'documentDate',
    CREATE_DATE = 'createDate',
}
